import { useQuery } from "@tanstack/react-query";
import { Hash, ScrollText } from "lucide-react";

import { EmptyState } from "@/components/EmptyState";
import { PageHeader } from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { Table, TBody, TD, TH, THead, TR } from "@/components/ui/table";
import { api, type AuditRow } from "@/lib/api";
import { fmtTime } from "@/lib/utils";

export default function Audit() {
  const { data } = useQuery({
    queryKey: ["audit"],
    queryFn: () => api.get<{ items: AuditRow[] }>("/api/audit?limit=200").then((r) => r.items),
    refetchInterval: 30_000,
  });

  return (
    <div className="space-y-5">
      <PageHeader
        title="Audit Log"
        description="Append-only and hash-chained — the runtime DB role is denied UPDATE/DELETE at the privilege layer. Each row's hash commits to its content plus the previous row's hash."
      />
      <Card>
        <Table>
          <THead>
            <TR><TH>Time</TH><TH>Actor</TH><TH>Action</TH><TH>Target</TH><TH>IP</TH><TH>Chain</TH></TR>
          </THead>
          <TBody>
            {(data ?? []).map((a) => (
              <TR key={a.id}>
                <TD className="whitespace-nowrap text-xs">{fmtTime(a.at)}</TD>
                <TD className="text-xs">{a.actor}</TD>
                <TD className="font-mono text-xs">{a.action}</TD>
                <TD className="max-w-[200px] truncate font-mono text-xs" title={a.target}>{a.target}</TD>
                <TD className="font-mono text-xs">{a.ip}</TD>
                <TD className="font-mono text-[10px] text-muted-foreground" title={a.hash}>
                  <Hash className="mr-1 inline h-3 w-3" />{a.hash.slice(0, 10)}…
                </TD>
              </TR>
            ))}
          </TBody>
        </Table>
        {(data ?? []).length === 0 && (
          <EmptyState icon={ScrollText} title="No audit events yet"
            hint="Logins, applies, exceptions, bans and setting changes are recorded here." />
        )}
      </Card>
    </div>
  );
}
